import { Server, Model, Factory } from "miragejs";
import * as Chance from "chance";
import { addDays, isBefore } from "date-fns";
const chance = new Chance();

const hotels = [
  {
    name: "The Source Hotel",
    address: "3330 Brighton Blvd",
    city: "Denver",
    state: "CO",
    zip: "80216",
  },
  {
    name: "Hotel Indigo Denver Downtown",
    address: "1801 Wewatta St",
    city: "Denver",
    state: "CO",
    zip: "80202",
  },
  {
    name: "The Maven Hotel at Dairy Block",
    address: "1850 Wazee St",
    city: "Denver",
    state: "CO",
    zip: "80202",
  },
  {
    name: "The Crawford Hotel",
    address: "1701 Wynkoop St",
    city: "Denver",
    state: "CO",
    zip: "80202",
  },
];

// const guests = ["Jane Doe", "John Smith", "Johnny Appleseed", "Aunt Jemima"];
const guests = Array.from({ length: 4 }).map((_, i, arr) => ({
  name: chance.name(),
  hotel_name: hotels[i].name,
  contract_number: chance.string({
    length: 7,
    casing: "upper",
    alpha: true,
    numeric: true,
  }),
  group_reservation_id: chance.string({
    length: 21,
    casing: "upper",
    alpha: true,
    numeric: true,
  }),
  check_in: chance.date({
    month: new Date().getMonth(),
    day: chance.integer({ min: 1, max: 31 }),
    year: 2020,
  }),
  state: chance.pick([
    "visiting",
    "completed",
    "cancelled",
    "booked",
    "needs_attention",
  ]),
  pending_update: chance.pick([true, false]),
  customer_total: chance.dollar().replace("$", ""),
}));

// let count = 0;

export function makeServer({ environment = "development" }) {
  return new Server({
    environment,
    models: {
      hotel_partner: Model,
      hotel_partner_availability: Model,
      contract: Model,
    },
    factories: {
      contract: Factory.extend({
        hotel_name(i) {
          return guests[i].hotel_name;
        },
        guest_first(i) {
          return guests[i].name.split(" ")[0];
        },
        guest_last(i) {
          return guests[i].name.split(" ")[1];
        },
        contract_number(i) {
          return guests[i].contract_number;
        },
        group_reservation_id(i) {
          return guests[i].group_reservation_id;
        },
        check_in(i) {
          return guests[i].check_in;
        },
        check_out(i) {
          return addDays(new Date(guests[i].check_in), 5);
        },
        state(i) {
          return isBefore(addDays(new Date(guests[i].check_in), 5), new Date())
            ? "completed"
            : guests[i].state === "completed"
            ? chance.pick([
                "visiting",
                "cancelled",
                "booked",
                "needs_attention",
              ])
            : guests[i].state;
        },
        pending_update(i) {
          return guests[i].pending_update;
        },
        customer_total(i) {
          return guests[i].customer_total;
        },
      }),
    },
    seeds(server) {
      server.create("hotel_partner", {
        booking_link: undefined,
        // "https://be.synxis.com/?adult=2&arrive=2020-04-17&chain=10237&child=0&configcode=DENTS&currency=USD&depart=2020-04-20&hotel=77854&level=hotel&locale=en-US&rooms=1&themecode=DENTS&trifecta=1",
        property_name: "The Source Hotel",
        property_street: "3330 Brighton Blvd",
        property_city: "Denver",
        property_state: "CO",
        property_postal_code: "80216",
        created_at: new Date(),
        updated_at: new Date(),
        updated_by: "Jonathan Glock",
      });

      // server.createList("hotel_partner", 4);

      server.create("hotel_partner_availability", {
        one_bed_rooms: 0,
        two_bed_rooms: 1,
        rooms_by_floor: 2,
        accessible_rooms: 0,
        cribs: 0,
        rollaways: 1,
        rooms_with_kitchen: 3,
        rooms_with_fridge: 3,
        rooms_with_microwave: 5,
        total_rooms: 10,
        updated_by: "Jonathan Glock",
        updated_at: new Date(),
        missed_check_ins: [],
      });

      // server.create("contract", {
      //   hotel_name: "The Source Hotel",
      //   guest_name: "Jane Doe",
      //   guest_unique_id: 229,
      // });
      server.createList("contract", 4);
    },
    routes() {
      this.urlPrefix = process.env.REACT_APP_HE_API_HOST;
      // this.namespace = "/hotel_partners";

      this.passthrough(`${process.env.REACT_APP_FOLIO_HOST}/**`);

      this.passthrough(
        "https://2wa2949mr7.execute-api.us-east-1.amazonaws.com/staging/upload"
      );

      this.get(
        "/hotel_partners/:id/contracts/:contract_number",
        (schema, request) => {
          // const found = schema.contracts.findBy({
          //   hotel_name: "The Source Hotel",
          // });
          // console.log(`schema.contracts: `, schema.contracts);
          // console.log(`request.params: `, request.params);
          const found = schema.contracts.findBy({
            contract_number: request.params.contract_number,
          });
          if (found) return { ...found.attrs, uuid: found.attrs.id };
        }
      );

      this.post(
        "/hotel_partners/:id/contracts/:contract_number/folio_details",
        (schema, request) => {
          let attrs = JSON.parse(request.requestBody);
          return { ...attrs, updated_at: new Date() };
        }
      );

      this.get("/hotel_partners/:id/contracts", (schema, request) => {
        // count++;
        const all = schema.contracts.all();
        // if (count > 1) return all.models;
        return all.models;
        // return new Response(429, {}, { errors: ["Too many requests"] });
      });

      this.get(
        "/hotel_partners/:id/hotel_partner_availabilities",
        (schema, request) => {
          // let id = request.params.id;

          const found = schema.hotelPartnerAvailabilities.findBy({
            updated_by: "Jonathan Glock",
          });
          if (found) return { ...found.attrs, uuid: found.attrs.id };
          // return;
          // return new Response(
          //   400,
          //   { some: "header" },
          //   { errors: ["name cannot be blank"] }
          // );
        }
      );

      this.post(
        "/hotel_partners/:id/hotel_partner_availabilities",
        (schema, request) => {
          let attrs = JSON.parse(request.requestBody);
          console.log(`attrs: `, attrs);
          return {
            ...attrs,
            updated_at: new Date(),
            property_name: "The Source Hotel",
            property_street: "3330 Brighton Blvd",
            property_city: "Denver",
            property_state: "CO",
            property_postal_code: "80216",
          };
          // return new Response(
          //   400,
          //   { some: "header" },
          //   { errors: ["name cannot be blank"] }
          // );
        }
      );

      this.get("/hotel_partners/:id", (schema, request) => {
        const found = schema.hotelPartners.findBy({
          updated_by: "Jonathan Glock",
        });
        if (found) return { ...found.attrs, uuid: found.attrs.id };
      });

      this.put("/hotel_partners/:id", (schema, request) => {
        let attrs = JSON.parse(request.requestBody);
        console.log(`attrs: `, attrs);
        return {
          ...attrs,
          // updated_at: new Date(),
          // property_name: "The Source Hotel",
          // property_street: "3330 Brighton Blvd",
          // property_city: "Denver",
          // property_state: "CO",
          // property_postal_code: "80216",
        };
        // return new Response(
        //   400,
        //   { some: "header" },
        //   { errors: ["name cannot be blank"] }
        // );
      });
    },
  });
}
